<template>
<small
    v-if="answer?.option?.is_free_text"
    class="font-weight-bold"
>
    Other - {{ answer.answer }}
</small>
</template>

<script>
export default {
    props: [
        'answer'
    ],
}
</script>
